import Report from "components/Report";

const TraineeReports = () => <Report type="trainee" />;

export default TraineeReports;
